import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import Title from "../components/Title"
import Layout from "../components/Layout"
import Seo from "../components/Seo"

const Tours = () => {
  return (
    <Layout>
      <Seo title="Tours" />
      <Container>
        <section className="hero-wrapper">
          <div className="overlay"></div>
          <Title title="Convenios con:" className="title-absolute" />
          <StaticImage
            src="../assets/images/osorno.jpg"
            layout="constrained"
            className="img"
            alt="osorno"
          />
        </section>
        <section className="section section-center tour-section">
          <div className="tour-center">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://contentour.cl/es/"
            >
              <StaticImage
                src="../assets/images/tour.jpg"
                layout="constrained"
                alt="tours"
              />
            </a>

            <div className="info">
              <p>
                En Loki Rent a Car Puerto Montt y Puerto Varas ofrecemos
                convenios con Contentour, empresa ubicada en una de las ciudades
                más hermosas de la décima región. Contentour nace bajo la idea
                de una pareja de jóvenes unidos por la pasión de viajar y el
                amor a su tierra. A partir de este concepto, buscan ampliar la
                oferta turística de la zona, potenciando y aportando al
                emprendimiento local.
              </p>
              <p>
                En Contentour estamos impulsando nuevas rutas de excursión, que
                permitan rodearse de naturaleza en su forma más pura,
                proyectando el amor y cuidado al medio ambiente. Fomentamos
                además excursiones clásicas e imperdibles del sector. Asimismo,
                resaltamos el emprendimiento local de diversas áreas
                relacionadas al rubro. Contamos además con el apoyo y respaldo
                de Sernatur y la oficina de información turística de Puerto
                Varas
              </p>
            </div>
          </div>
        </section>
      </Container>
    </Layout>
  )
}

export default Tours

const Container = styled.div`
  background: var(--white);
  .hero-wrapper {
    width: 100%;
    height: 408px;
    position: relative;
    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1));
      z-index: 1;
    }
    .img {
      width: 100%;
      height: 100%;
    }
  }
  .section {
    padding: 5rem 12px;
  }

  .tour-center {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .info {
    margin-top: 4rem;
  }
  a {
    margin: 0 auto;
  }

  @media (min-width: 772px) {
    .info {
      margin-top: 0;
    }
  }
`
